import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';
import { PublicCustomer } from '@sb-tools/typescript/models/public-customer.model';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { Subject, takeUntil } from 'rxjs';
import { CustomerConfigurationService } from '../core/services/customer-configuration.service';

@Component({
    selector: 'app-access-expired',
    templateUrl: './access-expired.component.html',
    styleUrls: ['./access-expired.component.scss'],
    imports: [TranslateModule],
})
export class AccessExpiredComponent implements OnInit {
    customer: PublicCustomer;

    private unsubscriber = new Subject<void>();

    constructor(
        private customerConfigurationService: CustomerConfigurationService,
        private commonDataService: CommonDataService,
        private translateService: TranslateService,
    ) {}

    ngOnInit(): void {
        if (document.body.clientWidth <= 1000) {
            document.body.classList.add('mobile');
        }
        this.customerConfigurationService
            .getPublicCustomer()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe({
                next: (customer: PublicCustomer) => {
                    this.customer = customer;
                    this.setupLanguage(this.customer.language);
                },
            });
    }

    private setupLanguage(language: LocalizationLanguage) {
        switch (language) {
            case LocalizationLanguage.norwegian:
                this.commonDataService.language = 'nb';
                this.translateService.use('nb');
                break;
            case LocalizationLanguage.swedish:
                this.commonDataService.language = 'sv_SE';
                this.translateService.use('sv_SE');
                break;
            case LocalizationLanguage.danish:
                this.commonDataService.language = 'da_DK';
                this.translateService.use('da_DK');
                break;
            case LocalizationLanguage.finnish:
                this.commonDataService.language = 'fi';
                this.translateService.use('fi');
                break;
            default:
                this.commonDataService.language = 'en';
                this.translateService.use(undefined);
        }
    }
}
